import { useState, useEffect } from 'react';
import "./Notification.Page.scss";
import Header from "./Header";
import FilterAndActions from "./FilterAndActions";
import NotificationResult from "./NotificationResult";
import Slider from './Slider';
import Footer from "./Footer";
import Calendar from "./Calendar";
import moment from "moment";
import { fetchApi } from '../../services/apiService';

export const Notification = () => {

  const [sliderCal, setSliderCal] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [serviceDueOnDt, setServiceDueOnDt] = useState(moment(new Date()).format('ddd, DD-MMM-YY'));
  const [dateSelectionMode, setDateSelectionMode] = useState(1) //notification date by default
  const [notificationData, setNotificationData] = useState(false);

  const handelExpandAll = (checked) => {
    setExpandAll(checked);
  }

  const handleReminderDate = (val) => {
    // setServiceDueOnDt(moment(new Date()).format('ddd, DD-MMM-YY'))
    setDateSelectionMode(val)
  }

  const openSlider = () => {
    setSliderCal(true)
  }

  const closeSlider = () => {
    setSliderCal(false);
  }

  const handleDateSelect = (dt) => {
    setDateSelectionMode(1)
    setServiceDueOnDt(moment(dt).format('ddd, DD-MMM-YY'));
    closeSlider();
  }

  useEffect(() => {

    const getNotificaton = async () => {

      const queryParameters = new URLSearchParams(window.location.search);
      const token = queryParameters.get("token");
      let getUserParams = {};

      if (dateSelectionMode === 1) {
        let dueOnDate = moment(serviceDueOnDt).format('YYYY-MM-DD');
        getUserParams = {
          serviceDueAsOn: dueOnDate, serviceDueAs: 'A'
        };
      } else if (dateSelectionMode === 2) {
        getUserParams = {
          serviceDueAs: 'N'
        };
      }

      const response = await fetchApi('notification/getServiceDueReport?token=' + token, getUserParams);
      if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
        if (response.data.serviceDueDetails.length > 0) {
          setNotificationData(response.data.serviceDueDetails);
        } else {
          setNotificationData(false);
        }
      }
    }

    getNotificaton();

  }, [serviceDueOnDt, dateSelectionMode]);

  return (
    <div className="notification--container">
      <div className="notification--contain">
        <Header />
        <FilterAndActions handleReminderDate={handleReminderDate} handelExpandAll={handelExpandAll} openSlider={openSlider} serviceDueOnDt={serviceDueOnDt} />
        <NotificationResult expandAll={expandAll} notificationData={notificationData} />
        <Slider active={sliderCal}>
          <Calendar
            onClose={closeSlider}
            selectedDate={serviceDueOnDt}
            onSel={(dt) => { handleDateSelect(dt) }} />
        </Slider>
        <Footer />
      </div>
    </div>
  );
};